import React from 'react';
import TagBatchAction from 'components/v2/FlexTable/TagBatchAction';
import { withFeatureState } from './state';

export const Tag = withFeatureState(({ ...rest }) => {
  const props = { taggableType: 'Company::Template' };
  return <TagBatchAction {...rest} {...props} />;
});
